export interface UnitSetting {
  id?: string;
  unit: number;
}

export const DEFAULT_UNIT_SETTING: UnitSetting = {
  id: undefined,
  unit: 0 // Hybrid
};
